/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Xray_EnableInputs */

const en_xray_enable = /** @type {(inputs: Xray_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show robots through walls`)
};

const fr_xray_enable = /** @type {(inputs: Xray_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir les robots à travers les murs`)
};

const ms_sg2_xray_enable = /** @type {(inputs: Xray_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat robot melalui dinding`)
};

/**
* | output |
* | --- |
* | "Show robots through walls" |
*
* @param {Xray_EnableInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const xray_enable = /** @type {((inputs?: Xray_EnableInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Xray_EnableInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_xray_enable(inputs)
	if (locale === "fr") return fr_xray_enable(inputs)
	return ms_sg2_xray_enable(inputs)
});